module.exports = __webpack_public_path__ + "static/title-graphic-8fc09fe0765a8ee5c57ef3b8512ba5dd.png";